import { render, staticRenderFns } from "./AbkSurveysList.vue?vue&type=template&id=18afd666&scoped=true&"
import script from "./AbkSurveysList.vue?vue&type=script&lang=js&"
export * from "./AbkSurveysList.vue?vue&type=script&lang=js&"
import style0 from "./AbkSurveysList.vue?vue&type=style&index=0&id=18afd666&scoped=true&lang=scss&"
import style1 from "./AbkSurveysList.vue?vue&type=style&index=1&id=18afd666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18afd666",
  null
  
)

export default component.exports